document.addEventListener('DOMContentLoaded', () => {
  const activeCurrency = window.Shopify?.currency?.active || 'EUR';
  const rawRate = Number(window.Shopify?.currency?.rate || (activeCurrency === 'EUR' ? 1 : 0));
  const rate = Number.isFinite(rawRate) && rawRate > 0 ? rawRate : null;
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:activeCurrency}).format(Number(cents || 0) / 100);
  const convertBaseCents = (baseCents) => {
    if (activeCurrency === 'EUR') return Math.round(Number(baseCents || 0));
    if (!rate) return null;
    return Math.round(Number(baseCents || 0) * rate);
  };

  const shippingThreshold = convertBaseCents(6000);
  const announcement = document.querySelector('[data-shipping-announcement]');
  if (announcement && shippingThreshold) {
    announcement.textContent = `FREE SHIPPING ON ${money(shippingThreshold)}+ ORDERS • BUY 3, GET 1 TEE FREE`;
  }

  const updateCartShippingProgress = async () => {
    const node = document.querySelector('.cart-progress--page > p:first-child');
    if (!node || !shippingThreshold) return;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      node.textContent = cart.total_price >= shippingThreshold
        ? 'FREE SHIPPING UNLOCKED'
        : `${money(Math.max(0, shippingThreshold - cart.total_price))} away from FREE SHIPPING`;
    } catch (_) {}
  };
  updateCartShippingProgress();

  const parseVariants = (form) => {
    try { return JSON.parse(form.querySelector('[data-product-variants]')?.textContent || '[]'); }
    catch (_) { return []; }
  };

  const refreshProductOffers = (form) => {
    const variants = parseVariants(form);
    const variantId = form.querySelector('[data-variant-id]')?.value;
    const variant = variants.find((item) => String(item.id) === String(variantId)) || variants[0];
    if (!variant) return;
    form.querySelectorAll('[data-offer]').forEach((offer) => {
      const kind = offer.dataset.offerKind || 'standard';
      if (kind === 'standard') return;
      const regularCount = Number(offer.dataset.offerRegularCount || 1);
      const selectedLines = Array.from(offer.querySelectorAll('[data-bundle-plus].is-filled'));
      const linePrices = [Number(variant.priceCents || 0), ...selectedLines.map((line) => Number(line.dataset.priceCents || variant.priceCents || 0))];
      while (linePrices.length < regularCount) linePrices.push(Number(variant.priceCents || 0));
      const regularCents = linePrices.slice(0, regularCount).reduce((sum, price) => sum + price, 0);
      const total = offer.querySelector('[data-offer-total]');
      const saving = offer.querySelector('[data-offer-saving]');
      let savingCents = 0;

      if (kind === 'fixed') {
        const fixedBaseCents = activeCurrency === 'EUR' ? Number(offer.dataset.offerFixedBaseCents || 1000) : 866;
        const converted = convertBaseCents(fixedBaseCents);
        if (converted == null) {
          if (total) total.textContent = money(regularCents);
          if (saving) saving.textContent = 'Discount applied at checkout';
          return;
        }
        savingCents = Math.min(converted, regularCents);
      }

      if (kind === 'buy3get1') {
        const freeLine = selectedLines.find((line) => line.dataset.bundleRole === 'free');
        const freePrice = Number(freeLine?.dataset.priceCents || variant.priceCents || 0);
        const convertedCap = convertBaseCents(Number(offer.dataset.offerFreeCapBaseCents || 3500));
        if (convertedCap == null) {
          if (total) total.textContent = money(regularCents);
          if (saving) saving.textContent = 'Free tee discount applied at checkout';
          return;
        }
        savingCents = Math.min(convertedCap, freePrice);
      }

      const saleCents = Math.max(0, regularCents - savingCents);
      if (total) total.innerHTML = savingCents ? `${money(saleCents)} <del>${money(regularCents)}</del>` : money(saleCents);
      if (saving) saving.textContent = savingCents ? `You save ${money(savingCents)}` : 'Standard price';
    });
  };

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const run = () => window.setTimeout(() => refreshProductOffers(form), 0);
    run();
    form.addEventListener('click', run);
    form.addEventListener('change', run);
  });

  const refreshBuilder = (builder) => {
    const tabs = Array.from(builder.querySelectorAll('[data-bundle-count]'));
    const target = Number(tabs.find((tab) => tab.getAttribute('aria-pressed') === 'true')?.dataset.bundleCount || builder.dataset.defaultBundleCount || 2);
    const choices = Array.from(builder.querySelectorAll('[data-bundle-choice]'));
    const selected = choices.filter((choice) => choice.querySelector('[data-bundle-check]')?.checked);
    const subtotal = selected.reduce((sum, choice) => sum + Number(choice.querySelector('[data-bundle-variant]')?.selectedOptions[0]?.dataset.price || 0), 0);
    const totalNode = builder.querySelector('[data-bundle-total]');
    const savingNode = builder.querySelector('[data-bundle-saving]');
    const addButton = builder.querySelector('[data-bundle-add]');
    let savingCents = 0;

    if (target === 4) {
      const cap = convertBaseCents(Number(builder.dataset.discountFourCapBaseCents || 3500));
      const lastPrice = Number(selected.at(-1)?.querySelector('[data-bundle-variant]')?.selectedOptions[0]?.dataset.price || 0);
      if (cap != null) savingCents = Math.min(cap, lastPrice);
    } else {
      const fixedBaseCents = activeCurrency === 'EUR' ? Number(builder.dataset.discountTwoBaseCents || 1000) : 866;
      const fixed = convertBaseCents(fixedBaseCents);
      if (fixed != null) savingCents = Math.min(fixed, subtotal);
    }

    if (totalNode) totalNode.textContent = money(Math.max(0, subtotal - savingCents));
    if (savingNode) {
      if (selected.length !== target) savingNode.textContent = `Choose ${target} items`;
      else if (!rate && activeCurrency !== 'EUR') savingNode.textContent = 'Discount applied at checkout';
      else savingNode.textContent = `Save ${money(savingCents)} at checkout`;
    }
    if (addButton) addButton.disabled = selected.length !== target;
  };

  document.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
    const run = () => window.setTimeout(() => refreshBuilder(builder), 0);
    run();
    builder.addEventListener('click', run);
    builder.addEventListener('change', run);
  });
});
